{
  "title": "Compartir tu ubicación te permite agilizar el proceso de registro",
  "body": "Lo sentimos, pero no podemos completar tu registro sin acceso a tu ubicación. Por favor otorga acceso a la ubicación para continuar. Solo usamos tu ubicación para el registro en el almacén y no almacenamos ni compartimos tu información de ubicación con terceros.",
  "shareLocation": "Compartir mi ubicación"
}
